// API Configuration - Single base URL
// In production, set REACT_APP_BASE_URL to your domain or leave empty for same-origin
// In development, defaults to https://localhost:7084
const isProduction = process.env.NODE_ENV === 'production';
const baseUrl = isProduction ? '' : (process.env.REACT_APP_BASE_URL || 'https://localhost:7084');

export const API_CONFIG = {
  BASE_URL: baseUrl,
  API_URL: `${baseUrl}/api`,
  TIMEOUT: 30000, // 30 seconds
} as const;

// Helper function to get full image URL
// API returns paths like "/uploads/products/image.jpg"
// In production (same origin): "/uploads/products/image.jpg"
// In development: "https://localhost:7084/uploads/products/image.jpg"
export const getImageUrl = (path: string | undefined): string => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${baseUrl}${path}`;
};
